import { onPageLoad } from '../modules/page_lifecycle.js';
import { initBootstrapTooltipsAndPopovers } from '../modules/bootstrap_ui.js';
import { qs, qsa } from '../modules/dom.js';

function highlightGeographicNavigation() {
  qsa('#geographicNavigation a').forEach((anchor) => {
    const href = anchor.getAttribute('href')?.replace(window.location.origin, '') || '';
    anchor.classList.remove('active');

    if (window.location.pathname === '/') {
      if (anchor.textContent.trim() === 'Home') anchor.classList.add('active');
      return;
    }

    if (href === window.location.pathname) {
      anchor.classList.add('active');
    } else if (window.location.pathname.match(/regions|countries/)) {
      qs('#regions_and_countries')?.classList.add('active');
    }
  });
}

function bindGlobalSearchPlaceholder() {
  const input = qs('#q');
  if (!input) return;

  input.addEventListener('focus', () => {
    if (input.value === 'Search') input.value = '';
  });

  input.addEventListener('blur', () => {
    if (input.value === '') input.value = 'Search';
  });
}

function submitHiddenLoginForm() {
  const form = qs('#dklogin_hidden');
  if (!form) return;

  form.setAttribute('action', `${window.ENV_URL}/login/external`);
  const envInput = qs('#dk_env', form);
  if (envInput) envInput.value = window.ENV;
  form.submit();
}

onPageLoad(() => {
  highlightGeographicNavigation();
  bindGlobalSearchPlaceholder();
  submitHiddenLoginForm();
  initBootstrapTooltipsAndPopovers();
});
